import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

class Timeline {
    constructor() {
        const timelines = document.querySelectorAll('.timeline .splide');

        if (!timelines.length) return false;

        timelines.forEach((timeline) => {
            Timeline.init(timeline);
        });
    }

    static init(elem) {
        const splide = new Splide(elem, {
            pagination: false,
            arrows: true,
            perMove: 1,
            autoWidth: true,
        });

        splide.mount();
    }
}

export default Timeline;
